<script setup lang="ts">
import useAppStore from '@/stores/app';
import EnvelopeIcon from '@/icons/EnvelopeIcon.vue';
import XIcon from '@/icons/XIcon.vue';
import LinkedInIcon from '@/icons/LinkedInIcon.vue';

// Instances
const appStore = useAppStore();

// Data
const {footer, contacts} = storeToRefs(appStore);
</script>

<template>
    <footer
        v-if="footer"
        class="border-t border-orange-700 p-4 md:py-4.5 md:px-20"
    >
        <div
            class="space-y-4 max-w-360 mx-auto md:space-y-0 md:flex md:items-center md:justify-between md:gap-8"
            :class="{'md:flex-row-reverse': true || (footer.links.length > 0)}"
        >
            <nav
                v-if="true || (footer.links.length > 0)"
                aria-label="Footer navigation"
                class="md:shrink md:min-w-0"
            >
                <div class="overflow-x-auto no-scrollbar px-4 -mx-4 md:px-0 md:mx-0">
                    <ul class="flex items-center gap-8 text-sm/5 whitespace-nowrap w-max mx-auto md:text-base/6 md:justify-end">
                        <template v-for="item in footer.links" :key="item.id">
                            <li>
                                <Link
                                    :to="item.link"
                                    :text="item.title"
                                />
                            </li>
                        </template>

                        <li v-if="contacts?.email">
                            <a :href="`mailto:${contacts.email}`">
                                <EnvelopeIcon class="block w-6 h-6"/>
                            </a>
                        </li>
                        <li v-if="contacts?.x">
                            <a :href="contacts.x" target="_blank">
                                <XIcon class="block w-6 h-6"/>
                            </a>
                        </li>
                        <li v-if="contacts?.linkedin">
                            <a :href="contacts.linkedin" target="_blank">
                                <LinkedInIcon class="block w-6 h-6"/>
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>

            <div
                v-if="footer.copyright"
                class="text-xs/4 text-gray-500 text-center md:text-sm/5 md:shrink-0"
                v-html="footer.copyright"
            />
        </div>
    </footer>
</template>

<style scoped>

</style>
